import styled from "styled-components";

const ContentDiv = styled.div`
  margin-bottom: 20px;
  margin-top: 20px;
`;

export default ContentDiv;
